export default __webpack_public_path__ + "static/media/glitter.f22191dd.gif";